/**
 * Checks if a patch test date is valid (not older than six months).
 *
 * Backend sends: "2026-02-23T12:00:00Z" (ISO 8601 UTC format)
 * JavaScript converts to local timezone, then we normalize to midnight for comparison.
 *
 * @param {string|Date} date - The date of the patch test (ISO string or Date object).
 * @returns {boolean|null} - Returns true if the patch test is still valid (not expired),
 *                           false if it has expired (older than 6 months),
 *                           or null if the date is invalid.
 */
export const isPatchTestValid = (date) => {
  if (!date) return null;

  const parsedDate = new Date(date);

  if (isNaN(parsedDate)) {
    return null;
  }

  // Normalize to start of day (midnight) in local timezone to avoid time-of-day issues
  // This extracts the LOCAL date parts (what the user sees) and creates a new Date at midnight
  const patchTestDateNormalized = new Date(parsedDate.getFullYear(), parsedDate.getMonth(), parsedDate.getDate());

  // Calculate six months ago from today at midnight
  const now = new Date();
  const sixMonthsAgo = new Date(now.getFullYear(), now.getMonth() - 6, now.getDate());

  // Patch test is valid if it's more recent than 6 months ago
  return patchTestDateNormalized >= sixMonthsAgo;
};
